<template>
  <div class="wc-dialog-overlay" v-if="props.modelValue" @click.self="handleClose" @touchmove.prevent @wheel.prevent>
    <div class=" confirm-dialog" @touchmove.stop @wheel.stop>
      <div class="wc-dialog-body">
        <p class="confirm-content">{{ content }}</p>
        <div class="confirm-actions flex-center">
          <div class="wc-btn secondary btn" @click="handleClose">
            {{ cancelText }}
          </div>
          <div class="wc-btn primary btn" @click="handleConfirm">
            {{ confirmText }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, defineEmits, defineProps, watch, onUnmounted } from 'vue'
import { useI18n } from 'vue-i18n'

const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  content: {
    type: String,
    default: '',
  },
  confirmText: {
    type: String,
    default: '',
  },
  cancelText: {
    type: String,
    default: '',
  },
})

// 禁止/恢复页面滚动
const lockScroll = () => {
  document.body.classList.add('no-scroll')
  document.documentElement.classList.add('no-scroll')
}

const unlockScroll = () => {
  document.body.classList.remove('no-scroll')
  document.documentElement.classList.remove('no-scroll')
}

const emit = defineEmits(['update:modelValue', 'confirm'])
const { t } = useI18n()

const confirmText = computed(() => props.confirmText || t('wc2026.login.submit'))
const cancelText = computed(() => props.cancelText || t('wc2026.login.cancel'))
const content = computed(() => props.content)

const handleClose = () => {
  emit('update:modelValue', false)
}

const handleConfirm = () => {
  emit('confirm')
}

watch(() => props.modelValue, (val) => {
  if (val) {
    lockScroll()
  } else {
    unlockScroll()
  }
}, { immediate: true })

onUnmounted(() => {
  unlockScroll()
})
</script>

<style lang="less" scoped>
@import '../shared.less';

.confirm-dialog {
  width: 673px;
  height: 336px;
  background-image: url('~@/assets/imgs/act/wc2026/confirmDialog/bg.png');
}

.confirm-content {
  text-align: center;
  color: #1b0926;
  font-size: 24px;
  line-height: 1.7;
  padding: 0 20px;
  height: 160px;
  margin-top: 60px;
  font-weight: bold;
  display: flex;
  align-items: center;
  justify-content: center;
}

.confirm-actions {
  margin-top: 0px;
  display: flex;
  justify-content: center;
  gap: 47px;
}
</style>
